import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { ShadowlessInputEl } from "common/components/input";
import { InvisibleSubmit } from "common/templates/mixins";
import { AuthContainerEl } from "common/widgets/auth-container";
export function template() {
  return /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx(AuthContainerEl, {
    attrs: { "show-footer-links": true }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".auth-form",
    attrs: { slot: `auth-form-slot` }
  }, /* @__PURE__ */ jsx("form", {
    attrs: {
      action: `/security/twofactor/verify/recovery-code/`,
      method: `post`
    },
    hook: {
      insert: this.helpers.onInsert
    }
  }, /* @__PURE__ */ jsx("h1", {
    sel: ".auth-form-title"
  }, "Enter Recovery Code"), /* @__PURE__ */ jsx("div", {
    sel: ".auth-form-subtitle"
  }, "Use your one time recovery code to log in.", ` `, /* @__PURE__ */ jsx("a", {
    sel: ".learn-more-link",
    attrs: {
      href: `https://docs.mixpanel.com/docs/admin/two-factor-authentication`,
      target: `_blank`
    }
  }, "Learn more")), /* @__PURE__ */ jsx("div", {
    sel: ".input-container"
  }, /* @__PURE__ */ jsx(ShadowlessInputEl, {
    attrs: {
      "auto-focus": true,
      "field-name": `recovery_code`,
      label: `Enter Recovery Code`,
      placeholder: `Recovery Code`,
      "validation-status": this.attr(`error`) !== `null` && this.state.formInputEmpty && `invalid`,
      "error-message": this.attr(`error`) !== `null` && this.attr(`error`).replaceAll(`"`, ``)
    },
    on: { input: this.helpers.setIsFormValueEmpty }
  }), /* @__PURE__ */ jsx("div", {
    sel: ".auth-form-field-row"
  }, /* @__PURE__ */ jsx("input", {
    attrs: {
      type: `hidden`,
      name: `csrfmiddlewaretoken`,
      value: this.helpers.getCsrfToken()
    }
  }), /* @__PURE__ */ jsx(ButtonEl, {
    attrs: {
      theme: ButtonTheme.Primary,
      icon: this.state.verificationInProgress && `spinner`,
      disabled: this.state.verificationInProgress
    },
    on: {
      click: this.helpers.submitForm
    }
  }, !this.state.verificationInProgress && `Log In`), /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".back-btn",
    attrs: {
      theme: ButtonTheme.Secondary,
      icon: this.state.navigationInProgress && `spinner`,
      disabled: this.state.navigationInProgress,
      href: `/security/twofactor/verify/totp/`
    },
    on: {
      click: this.helpers.handleClickBackButton
    }
  }, !this.state.navigationInProgress && `Back`))), InvisibleSubmit()))));
}
